var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmbr5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 76,
    viewBox: "0 0 95 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 37.6914C69 55.0884 54.897 69.1914 37.5 69.1914C20.103 69.1914 6 55.0884 6 37.6914C6 20.2944 20.103 6.19141 37.5 6.19141C54.897 6.19141 69 20.2944 69 37.6914Z",
    fill: "white",
    stroke: "#2C4245",
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6151 27.7994V41.4954H34.9031C35.3831 40.0554 36.5671 39.0314 38.4231 39.0314C40.9511 39.0314 42.2631 40.4714 42.2631 43.0954C42.2631 45.5594 41.0791 47.4154 38.4551 47.4154C36.2791 47.4154 34.9671 46.2314 34.5831 44.5994H30.2311C30.6151 48.4074 33.4951 51.1914 38.5191 51.1914C43.8311 51.1914 46.5831 47.7994 46.5831 43.0314C46.5831 39.4154 44.7271 35.3194 39.2871 35.3194C37.3351 35.3194 35.5751 36.1514 34.7111 37.2074V31.7354H45.0791V27.7994H30.6151Z",
    fill: "#32474A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36.4594C93.3333 37.2292 93.3333 39.1537 92 39.9235L72.5 51.1818C71.1667 51.9516 69.5 50.9893 69.5 49.4497L69.5 26.9331C69.5 25.3935 71.1667 24.4312 72.5 25.201L92 36.4594Z",
    fill: "#2C4245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmbr5);
export default __webpack_public_path__ + "static/media/nmbr5.6562aac9e329cd5c17ccd47d8adc5de9.svg";
export { ForwardRef as ReactComponent };